<script>
export default {
  name: 'SelectListItemNom',
  props: {
    item: {
      type: Object
    },
  },
}
</script>

<template>
  <div class="SelectListItemNom pl-3">
    <h3 class="text-md font-weight-bold mb-1 text-md">{{ item.nom }}</h3>
  </div>
</template>